/* eslint-disable */
export const ORDER_STATE = {
  1:"待支付",
  2:"已支付",
  3:"已超时",
  4:"已退款",
  5:"优惠券兑换",
  6:"已取消",
  7:"",
  8:"退款中",
}

// 课程小助手-联系方式类型：0无联系方式 1微信号、2QQ号、3QQ群号
export const CONTACT_WAY_TYPE= {
  NO_WAY: 0,
  WX: 1,
  QQ: 2,
  QQ_GROUP: 3,
}